import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Building2,
  Shield,
  AppWindow,
  FileText,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { usePermissions } from '@/hooks/use-permissions';

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', href: '/', permission: null },
  { icon: Building2, label: 'Tenants', href: '/admin/tenants', permission: 'hub.tenants.read' },
  { icon: Users, label: 'Users', href: '/admin/users', permission: 'hub.users.read' },
  { icon: Shield, label: 'Roles', href: '/admin/roles', permission: 'hub.roles.read' },
  { icon: AppWindow, label: 'Apps', href: '/admin/apps', permission: 'hub.apps.read' },
  { icon: FileText, label: 'Audit Logs', href: '/admin/audit', permission: 'hub.audit.read' },
];

export function Sidebar() {
  const location = useLocation();
  const permissions = usePermissions();

  const visibleItems = navItems.filter(
    (item) => !item.permission || permissions.has(item.permission)
  );

  return (
    <aside className="w-64 border-r bg-card min-h-screen">
      <div className="px-6 py-5 border-b">
        <Link to="/" className="block">
          <img
            src="/brand/logo-navy.png"
            alt="RF3"
            className="h-7 w-auto"
          />
          <span className="rf3-eyebrow mt-2 block">App Suite</span>
        </Link>
      </div>

      <nav className="px-3 py-4 space-y-1">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href;

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'relative flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground'
              )}
            >
              {isActive && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-1 rounded-r bg-rf3-amber" />
              )}
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
